import { render, staticRenderFns } from "./overseas.vue?vue&type=template&id=563ae566&scoped=true"
import script from "./overseas.vue?vue&type=script&lang=js"
export * from "./overseas.vue?vue&type=script&lang=js"
import style0 from "./overseas.vue?vue&type=style&index=0&id=563ae566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563ae566",
  null
  
)

export default component.exports